<template>
    <div style="width:100%">
        <Loading :value="loading"></Loading>
        <v-card tile class="pl-3 pr-3 pt-3  pb-3">
            <v-layout row>
                <v-flex sm3>
                    <v-card color="green darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                            <v-layout row>
                                <v-flex xs5>
                                    <div>
                                        <div class="title">{{dataNbFactFour.paye}}</div>
                                        <div>Facture(s) soldée(s)</div>
                                    </div>
                                </v-flex>
                                <v-flex xs7>
                                    <div>Montant déjà versé</div>
                                    <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFactFour.paye) }}</div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>

                <v-flex sm3>
                    <v-card color="orange darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                            <v-layout row>
                                <v-flex xs6>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <div>
                                                <div class="title">{{dataNbFactFour.cours}}</div>
                                                <div>Facture(s) en cours</div>
                                            </div>
                                        </v-flex>

                                         <v-flex xs12>
                                            <div>
                                                <div class="title">{{  new Intl.NumberFormat().format(dataNbFactFour.aValider) }}</div>
                                                <div>Facture(s) à valider </div>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                 <v-flex xs6>
                                     <v-layout row wrap>
                                        <v-flex xs12>
                                            <div> Montant déjà versé</div>
                                            <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFactFour.coursPaye) }}</div>
                                        </v-flex>
                                        <v-flex xs12>
                                            <div>Montant restant</div>
                                            <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFactFour.cours) }}</div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>

                <v-flex sm3>
                    <v-card color="blue-grey darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                            <v-layout row>
                                <v-flex xs5>
                                    <div>
                                        <div class="title">{{dataNbFactFour.attente}}</div>
                                        <div>Facture(s) en attente de paiement</div>
                                    </div>
                                </v-flex>
                                <v-flex xs7>
                                    <div>Montant restant</div>
                                    <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFactFour.attente) }}</div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>

                <v-flex sm3>
                    <v-card color="red darken-2" class="white--text elevation-5">
                        <v-container fluid grid-list-lg>
                            <v-layout row>
                                <v-flex xs5>
                                    <div>
                                        <div class="title">{{dataNbFactFour.impaye}}</div>
                                        <div>Facture(s) impayée(s)</div>
                                    </div>
                                </v-flex>
                                <v-flex xs7>
                                    <div>Montant restant</div>
                                    <div class="display-1">{{ new Intl.NumberFormat().format(dataMntFactFour.impaye)}}</div>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout row mt-2 mb-3>
                <v-flex sm12 class="text-xs-center">
                    <v-card class="elevation-5" style="height:550px">

                                <h4>Statistiques de l'etat des factures de l'année en cours </h4>
                                <v-divider class="mb-1"></v-divider>
                                <div class="mb-2" id="chartFactureAnFour" style="width: 100%; height:100%">
                                </div>

                    </v-card>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex sm6 class="mr-1">
                    <v-layout row>
                        <v-flex sm12>
                            <v-layout row class="elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4">
                                <v-flex sm8>
                                    <div id="chartCommandeFour" style="width:100%; height:100%">
                                        diagramme pie de commande
                                    </div>
                                </v-flex>

                                <!--Commande livre -->
                                <v-flex sm4>
                                    <v-layout row wrap class="pt-2 pl-2 pr-2 pb-2">
                                        <v-flex sm12>
                                            <v-card color="teal lighten-1" class="white--text elevation-5">
                                                <v-container fluid grid-list-lg>
                                                    <v-layout row>
                                                        <v-flex xs12>
                                                            <div>Commande(s) livrée(s)</div>
                                                            <div class="display-2">{{nbLivraisonFour}}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card>
                                        </v-flex>

                                        <v-flex sm12>
                                            <v-card color="deep-orange lighten-1" class="white--text elevation-5">
                                                <v-container fluid grid-list-lg>
                                                    <v-layout row>
                                                        <v-flex xs12>
                                                            <div>Commande(s) effectuée(s)</div>
                                                            <div class="display-2">{{nbCommandeFour}}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>


                                </v-flex>

                            </v-layout>

                        </v-flex>
                    </v-layout>

                </v-flex>

                <!-- diagramme pie facture-->
                <v-flex sm6 class="ml-1">
                    <div id="chartFactureFour" class="elevation-3 pt-2 pl-2 pr-2 pb-2 grey lighten-4" style="width: 100%; height:100%">
                        diagramme pie defacture
                    </div>
                </v-flex>
            </v-layout>

        </v-card>
    </div>
</template>

<script>
    var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'


    import Loading from '@/components/Loading'

    export default {
        components: {
            Loading,
            'v-chart': ECharts
        },
        name: "boardFacture",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            idFour: {

            }
        },
        data() {
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                loading: false,

                nbCommandeFour: 0,
                nbLivraisonFour: 0,
                dataCommandeFour:{},
                dataFactHistoFour:{},
                dataNbFactFour:{},
                dataMntFactFour:[]

            }
        },
        methods: {

            statDepenseAn(dataFactHistoFour) {
                var posList = [
                    'left', 'right', 'top', 'bottom',
                    'inside',
                    'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                    'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
                ];


                app.configParameters = {
                    rotate: {
                        min: -90,
                        max: 90
                    },
                    align: {
                        options: {
                            left: 'left',
                            center: 'center',
                            right: 'right'
                        }
                    },
                    verticalAlign: {
                        options: {
                            top: 'top',
                            middle: 'middle',
                            bottom: 'bottom'
                        }
                    },
                    position: {
                        options: echarts.util.reduce(posList, function (map, pos) {
                            map[pos] = pos;
                            return map;
                        }, {})
                    },
                    distance: {
                        min: 0,
                        max: 100
                    }
                };

                app.config = {
                    rotate: 90,
                    align: 'left',
                    verticalAlign: 'middle',
                    position: 'insideBottom',
                    distance: 15,
                    onChange: function () {
                        let  labelOption = {
                            normal: {
                                rotate: app.config.rotate,
                                align: app.config.align,
                                verticalAlign: app.config.verticalAlign,
                                position: app.config.position,
                                distance: app.config.distance
                            }
                        };
                        myChart.setOption({
                            series: [{
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }]
                        });
                    }
                };


                let labelOption = {
                    show: true,
                    position: app.config.position,
                    distance: app.config.distance,
                    align: app.config.align,
                    verticalAlign: app.config.verticalAlign,
                    rotate: app.config.rotate,
                    formatter: '{c}  {name|{a}}',
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: '#fff'
                        }
                    }
                };


                let option = {
                    color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {},
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        left: 'right',
                        top: 'center',
                        feature: {
                            mark: {show: true},
                            dataView: {show: true, readOnly: false},
                            magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                            restore: {show: true},
                            saveAsImage: {show: true}
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisTick: {show: false},
                            data: []
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [

                        {
                            name: 'Payé',
                            type: 'bar',
                            barGap: 0,
                            label: labelOption,
                            data: []
                        },
                        {
                            name: 'En cours',
                            type: 'bar',
                            label: labelOption,
                            data: []
                        },
                        {
                            name: 'En attente',
                            type: 'bar',
                            label: labelOption,
                            data: []
                        },
                        {
                            name: 'Impayé',
                            type: 'bar',
                            label: labelOption,
                            data: []
                        },
                    ]
                }; //option

                for(let datahis in dataFactHistoFour){
                    option.xAxis[0].data.push(datahis);

                    let series = dataFactHistoFour[datahis]

                    option.series[0].data.push(series["paye"]);
                    option.series[1].data.push(series["cours"]);
                    option.series[2].data.push(series["attente"]);
                    option.series[3].data.push(series["impaye"]);
                }

                //this.dataFactHisto.forEach(function(element) {
                    //console.log("element data histo", element)
                    //optionDepense.xAxis[0].data.push(element.date);
                    //optionDepense.series[0].data.push(element.montant)
                //})

                let chartFactureAnFour = echarts.init(document.getElementById('chartFactureAnFour'))
                chartFactureAnFour.setOption(option)
            },


            statFacture(dataNbFactFour) {
                let posList = [
                    'left', 'right', 'top', 'bottom',
                    'inside',
                    'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                    'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
                ];

                app.configParameters = {
                    rotate: {
                        min: -90,
                        max: 90
                    },
                    align: {
                        options: {
                            left: 'left',
                            center: 'center',
                            right: 'right'
                        }
                    },
                    verticalAlign: {
                        options: {
                            top: 'top',
                            middle: 'middle',
                            bottom: 'bottom'
                        }
                    },
                    position: {
                        options: echarts.util.reduce(posList, function (map, pos) {
                            map[pos] = pos;
                            return map;
                        }, {})
                    },
                    distance: {
                        min: 0,
                        max: 100
                    }
                };

                app.config = {
                    rotate: 90,
                    align: 'left',
                    verticalAlign: 'middle',
                    position: 'insideBottom',
                    distance: 15,
                    onChange: function () {
                        let  labelOption = {
                            normal: {
                                rotate: app.config.rotate,
                                align: app.config.align,
                                verticalAlign: app.config.verticalAlign,
                                position: app.config.position,
                                distance: app.config.distance
                            }
                        };
                        myChart.setOption({
                            series: [{
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }]
                        });
                    }
                };

                let labelOption = {
                    show: true,
                    position: app.config.position,
                    distance: app.config.distance,
                    align: app.config.align,
                    verticalAlign: app.config.verticalAlign,
                    rotate: app.config.rotate,
                    formatter: '{c}  {name|{a}}',
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: '#fff'
                        }
                    }
                };

                let option = {
                    backgroundColor: '#FFF',

                    title: {
                        text: "",
                        left: 'center',
                        top: 10,
                        textStyle: {
                            color: '#000'
                        }
                    },

                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },

                    visualMap: {
                        show: false,
                        min: 80,
                        max: 600,
                        inRange: {
                            colorLightness: [0, 1]
                        }
                    },
                    series: [
                        {
                            name: 'Nb Facture(s)',
                            type: 'pie',
                            radius: '75%',
                            center: ['50%', '50%'],
                            color:["#388E3C","#D32F2F","#455A64","#F57C00","#00BCD4"],
                            data: [
                                // {value: 335, name: '直接访问'},
                            ].sort(function (a, b) {
                                return a.value - b.value;
                            }),
                            roseType: 'radius',
                            label: {
                                color: 'rgba(255, 255, 255, 0.3)'
                            },
                            labelLine: {
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, 0.3)'
                                },
                                smooth: 0.2,
                                length: 10,
                                length2: 20
                            },
                            itemStyle: {
                                color: '#c23531',
                                shadowBlur: 200,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },

                            animationType: 'scale',
                            animationEasing: 'elasticOut',
                            animationDelay: function (idx) {
                                return Math.random() * 200;
                            }
                        }
                    ]
                };

                for(let dataFact in dataNbFactFour){
                    option.series[0].data.push({value:dataNbFactFour[dataFact], name:dataFact });

                }

                let chartFactureFour = echarts.init(document.getElementById('chartFactureFour'))
                chartFactureFour.setOption(option)
            },


            statCommande(dataCommandeFour) {
                let  posList = [
                    'left', 'right', 'top', 'bottom',
                    'inside',
                    'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                    'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
                ];


                app.configParameters = {
                    rotate: {
                        min: -90,
                        max: 90
                    },
                    align: {
                        options: {
                            left: 'left',
                            center: 'center',
                            right: 'right'
                        }
                    },
                    verticalAlign: {
                        options: {
                            top: 'top',
                            middle: 'middle',
                            bottom: 'bottom'
                        }
                    },
                    position: {
                        options: echarts.util.reduce(posList, function (map, pos) {
                            map[pos] = pos;
                            return map;
                        }, {})
                    },
                    distance: {
                        min: 0,
                        max: 100
                    }
                };

                app.config = {
                    rotate: 90,
                    align: 'left',
                    verticalAlign: 'middle',
                    position: 'insideBottom',
                    distance: 15,
                    onChange: function () {
                        let labelOption = {
                            normal: {
                                rotate: app.config.rotate,
                                align: app.config.align,
                                verticalAlign: app.config.verticalAlign,
                                position: app.config.position,
                                distance: app.config.distance
                            }
                        };
                        myChart.setOption({
                            series: [{
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }, {
                                label: labelOption
                            }]
                        });
                    }
                };


                let labelOption = {
                    show: true,
                    position: app.config.position,
                    distance: app.config.distance,
                    align: app.config.align,
                    verticalAlign: app.config.verticalAlign,
                    rotate: app.config.rotate,
                    formatter: '{c}  {name|{a}}',
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: '#fff'
                        }
                    }
                };

                let optionComd = {
                    title: {
                        text: 'Statistique des commandes',
                        subtext: '',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: ["Livraison(s)","Commande(s)"]
                    },
                    series: [
                        {
                            name: 'Commande(s)',
                            type: 'pie',
                            radius: '75%',
                            center: ['50%', '60%'],
                            color:[ "#26A69A","#FF7043"],
                            data: [
                                //{value: 1548, name: '搜索引擎'}
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                for(let dataCom in dataCommandeFour){
                    optionComd.series[0].data.push({value:dataCommandeFour[dataCom], name:dataCom });

                }

                this.nbCommandeFour = dataCommandeFour["commande"];
                this.nbLivraisonFour = dataCommandeFour["livraison"];


                let chartCommandeFour = echarts.init(document.getElementById('chartCommandeFour'))
                chartCommandeFour.setOption(optionComd)
            },

            loadAllDataFactAnFour(){
                this.loading = true
                let url = this.domaine + 'facture/stathisto/'+this.idFour

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.dataFactStatFour = response.body.dataFacture;
                        this.dataNbFactFour = response.body.dataNbFact;
                        this.dataMntFactFour = response.body.dataMntFacture;

                        this.statDepenseAn(this.dataFactStatFour)
                        this.statFacture(this.dataNbFactFour)
                        this.loading = false

                    }
                })
            },

            loadAllDataCommandeStatFour(){
                this.loading = true
                let url = this.domaine + 'facture/stat/general/'+this.idFour
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.dataCommandeStatFour = response.body.dataCommande;
                        this.statCommande(this.dataCommandeStatFour)
                        this.loading = false
                    }
                })
            },





            closeDialog() {
                this.$emit('close')
            },
        },

        watch: {
            show: function (newValue, oldvalue) {
                if(newValue == true){
                    this.loadAllDataCommandeStatFour()
                    this.loadAllDataFactAnFour()
                }
            }
        },

        mounted() {
        }


    }
</script>
<style>
    .list {
        height: auto !important;
    }

    .list__tile__sub-title {
        height: 300px;
    }

    .list__tile__title {
        height: 45px;
    }

    .list__tile__content, .list__tile__action {
        height: 73%;
    }

    .carousel {
        height: 560px;
    }

</style>



// WEBPACK FOOTER //
// src/components/tierce/boardFactureFournisseur.vue